var commonItemPropsArray = ['flex', 'flexBasis', 'flexGrow', 'alignSelf', 'flexShrink', 'm', 'mb', 'mt', 'my', 'me', 'mx', 'ms'];

export { commonItemPropsArray };
//# sourceMappingURL=types.js.map
